// extracted by mini-css-extract-plugin
export default {"tabMenu":"TabMenu_tabMenu__ZKRrv","tabs":"TabMenu_tabs__oOnQY"};